let historique = {
	idFunctionGroup: "",
	pile: []
};

historique.orientation = {portrait: "portrait", landscape: "landscape"};

historique.init = function () {
	historique.pile = [];
	historique.tamponEcran = null;

	if ( psa_params.data.isDoc === undefined ) {
		if ( typeof getListeVersionVehicule === "function" ) {
			var version = getListeVersionVehicule()[vehicleManager.uuidVersionSelected];
			if ( version.historique ) {
				historique.pile = version.historique;
			}
		}
	}
};

historique.erreurChargement = function () {
	const url = new URI("").setQuery({idEcran: historique.tamponEcran})
	history.replaceState({}, "", url.toString());
};

historique.getScrollValue = function () {
	let scrollValue;
	if ( historique.tamponEcran === pap.K_internalPageLocalisation ) {
		scrollValue = $("#app-content").find(".contentScrollable.currentView").scrollTop();
		preferences.setItem("localisation-list-scroll", scrollValue);
	} else if ( $("#app-content").find(".indexAlphaContent").length ) {
	scrollValue = $("#app-content").find(".indexAlphaContent").scrollTop()
	} else if ( $("#app-content").find("[data-multifunction='true']").length ) {
		scrollValue = $("#app-content").find("[data-function-active='true']").scrollTop();
	} else {
		scrollValue = $("#app-content").find(".contentScrollable").scrollTop();
	}
	return scrollValue;
};

historique.updateState = function () {
	const idEcran = pap.getIdEcranFromURL()
	const orientation = historique.getOrientation()
	const scrollValue = historique.getScrollValue()
	const urlToAdd = URI().setQuery({ orientation: orientation, scroll: scrollValue, idFunctionGroup: historique.idFunctionGroup, idEcran: idEcran, links: relatedLink.relatedLinksStates.join(",") })
		
	history.replaceState({}, "", urlToAdd.toString())
}

historique.addPage = function (newPage) {
	if (historique.tamponEcran) {
		historique.updateState()
		const orientation = historique.getOrientation()
		history.pushState({}, "", URI("").setQuery({orientation: orientation, idEcran: newPage}).toString())
	}

	historique.tamponEcran = newPage
	historique.saveToPreference()
	historique.popScanScreen()
};

historique.getOrientation = function () {
    var innerWidth = $("body").innerWidth();
    var innerHeight = $("body").innerHeight();

    if ( innerWidth > innerHeight ) {
        return historique.orientation.landscape;
    } else {
        return historique.orientation.portrait;
    }
};

historique.saveToPreference = function () {
	if ( psa_params.data.isDoc == undefined ) {
		if ( typeof getListeVersionVehicule === "function" ) {
			var version = getListeVersionVehicule()[vehicleManager.uuidVersionSelected];
			version.historique = historique.pile;
			saveToPreferenceVersion(version);
		}
	}
}

historique.popScanScreen = function() {
	var count = 0;
	if (historique && historique.pile && Array.isArray(historique.pile)) {
		for (var i = historique.pile.length - 1; i >= 0; i--) {
			var uri = new URI(historique.pile[i]);
			count += 1;

			if ( count >= psa_params.data.nbMaxSaveScanHistory && pap.getIdEcranFromURL(uri) === "scan.html" ) {
				delete historique.pile[i];
			}
		}
	}
}
